import React, { useEffect, useState } from 'react';
import { Bell, Menu } from 'lucide-react';
import { LogoHorizontal } from './Logo';
import { ReactComponent as AdsIcon } from '../assets/icons/ads.svg';
import api from '../lib/api';

export default function TopBar({ onPremiumClick, onBellClick, onMenuClick, isPremium = false }) {
    const [unread, setUnread] = useState(0);

    useEffect(() => {
        api.get('/notifications').then((r) => setUnread(r.data.unread_count || 0)).catch(() => {});
        const interval = setInterval(() => {
            api.get('/notifications').then((r) => setUnread(r.data.unread_count || 0)).catch(() => {});
        }, 30000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex items-center justify-between pt-4 pb-2">
            <LogoHorizontal size="md" />
            <div className="flex items-center gap-2">
                <button
                    onClick={onPremiumClick}
                    className="relative w-10 h-10 rounded-full flex items-center justify-center hover:bg-gray-100 transition"
                    data-testid="top-bar-premium-cta"
                    aria-label="Quitar publicidad"
                >
                    <AdsIcon className="w-6 h-6" />
                </button>
                <button onClick={onBellClick} className="relative w-10 h-10 rounded-full flex items-center justify-center hover:bg-gray-100 transition" data-testid="top-bar-notifications" aria-label="Notificaciones">
                    <Bell className="w-6 h-6 text-brand-navy" />
                    {unread > 0 && (
                        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1" data-testid="top-bar-notif-badge">
                            {unread > 9 ? '9+' : unread}
                        </span>
                    )}
                </button>
                <button onClick={onMenuClick} className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-gray-100 transition" data-testid="top-bar-menu" aria-label="Menú">
                    <Menu className="w-6 h-6 text-brand-navy" />
                </button>
            </div>
        </div>
    );
}
